/**
 * DashboardBreadcrumb
 *
 * A visual + behavioral clone of ReportBreadcrumb (the page-side publisher). It
 * publishes its items into the SAME shared BreadcrumbContext via `useSetBreadcrumb`
 * so the persistent `<BreadcrumbHost />` in the layout renders + animates them
 * identically to the reports breadcrumb. Labels for the editor are:
 *
 *   Dashboard > {clientName} > {dashboardName}
 *
 * Cloned (not imported) per the dashboards-reuse boundary: the report breadcrumb
 * file stays byte-identical; this re-exports the same shape with a dashboard name.
 */

import { type ReactNode } from "react";
import { useSetBreadcrumb } from "../../lib/breadcrumb";

export interface BreadcrumbItem {
  label: string;
  to?: string;
  onClick?: () => void;
}

/** Page-side publisher — renders nothing (the host renders the crumbs). */
export function DashboardBreadcrumb({
  items,
  trailing,
  onBeforeNavigate,
}: {
  items: BreadcrumbItem[];
  trailing?: ReactNode;
  onBeforeNavigate?: () => void;
}) {
  useSetBreadcrumb(items, { trailing, onBeforeNavigate });
  return null;
}
